





















































import 'vue-material-design-icons/styles.css'
import LeftIcon from 'vue-material-design-icons/ChevronLeftCircle'
import RightIcon from 'vue-material-design-icons/ChevronRightCircle'
import PlusIcon from 'vue-material-design-icons/PlusCircle'
import MinusIcon from 'vue-material-design-icons/MinusCircle'
import Flipbook from './Flipbook'

export default
  name: 'app'
  components: { Flipbook, LeftIcon, RightIcon, PlusIcon, MinusIcon }
  data: ->
    pages: [],
    pagesHiRes: [],
    hasMouse: true
    pageNum: null
  methods:
    onFlipLeftStart: (page) -> console.log 'flip-left-start', page
    onFlipLeftEnd: (page) ->
      console.log 'flip-left-end', page
      window.location.hash = '#' + page
    onFlipRightStart: (page) -> console.log 'flip-right-start', page
    onFlipRightEnd: (page) ->
      console.log 'flip-right-end', page
      window.location.hash = '#' + page
    onZoomStart: (zoom) -> console.log 'zoom-start', zoom
    onZoomEnd: (zoom) -> console.log 'zoom-end', zoom
    setPageFromHash: ->
      n = parseInt window.location.hash.slice(1), 10
      @pageNum = n if isFinite n
  mounted: ->
    window.addEventListener 'keydown', (ev) =>
      flipbook = @$refs.flipbook
      return unless flipbook
      flipbook.flipLeft() if ev.keyCode == 37 and flipbook.canFlipLeft
      flipbook.flipRight() if ev.keyCode == 39 and flipbook.canFlipRight

    # Simulate asynchronous pages initialization
    setTimeout (=>
      @pages = [
        null
        'images/cover.jpg'
        'images/index.jpg'
        'images/title.jpg'
        'images/title2.jpg'        
        'images/5.jpg'
        'images/6.jpg'
        'images/7.jpg'
        'images/8.jpg'
        'images/9.jpg'
        'images/10.jpg'
        'images/11.jpg'
        'images/12.jpg'
        'images/13.jpg'
        'images/14.jpg'
        'images/15.jpg'
        'images/16.jpg'
        'images/17.jpg'
        'images/18.jpg'
        'images/19.jpg'
        'images/20.jpg'
        'images/21.jpg'
        'images/22.jpg'
        'images/23.jpg'
        'images/24.jpg'
        'images/25.jpg'
        'images/26.jpg'
        'images/27.jpg'
        'images/28.jpg'
        'images/29.jpg'
        'images/30.jpg'
        'images/31.jpg'
        'images/32.jpg'
        'images/33.jpg'
        'images/34.jpg'
        'images/35.jpg'
        'images/36.jpg'
        'images/37.jpg'
        'images/38.jpg'
        'images/39.jpg'
        'images/40.jpg'
        'images/41.jpg'
        'images/42.jpg'
        'images/43.jpg'
        'images/44.jpg'
        'images/45.jpg'
        'images/46.jpg'
        'images/47.jpg'
        'images/48.jpg'
        'images/49.jpg'
        'images/50.jpg'
        'images/51.jpg'
        'images/52.jpg'
        'images/53.jpg'
        'images/54.jpg'
        'images/55.jpg'
        'images/56.jpg'
        'images/57.jpg'
        'images/58.jpg'
        'images/59.jpg'
        'images/60.jpg'
        'images/61.jpg'
        'images/62.jpg'
        'images/63.jpg'
        'images/64.jpg'
        'images/65.jpg'
        'images/66.jpg'
        'images/67.jpg'
        'images/68.jpg'
        'images/69.jpg'
        'images/70.jpg'
        'images/71.jpg'
        'images/72.jpg'
        'images/73.jpg'
        'images/74.jpg'
        'images/75.jpg'
        'images/76.jpg'
        'images/77.jpg'
        'images/78.jpg'
        'images/79.jpg'
        'images/80.jpg'
        'images/81.jpg'
        'images/82.jpg'
        'images/83.jpg'
        'images/84.jpg'
        'images/85.jpg'
        'images/86.jpg'
        'images/87.jpg'
        'images/88.jpg'
        'images/89.jpg'
        'images/90.jpg'
        'images/91.jpg'
        'images/92.jpg'
        'images/93.jpg'
        'images/94.jpg'
        'images/95.jpg'
        'images/96.jpg'
        'images/97.jpg'
        'images/98.jpg'
        'images/99.jpg'
        'images/100.jpg'
        'images/101.jpg'
        'images/102.jpg'
        'images/103.jpg'
        'images/104.jpg'
        'images/105.jpg'
        'images/106.jpg'
        'images/107.jpg'
        'images/108.jpg'
        'images/109.jpg'
        'images/110.jpg'
        'images/111.jpg'
        'images/112.jpg'            
      ]
      @pagesHiRes = [
        null
        'images-large/cover.jpg'
        'images-large/index.jpg'
        'images-large/title.jpg'
        'images-large/title2.jpg'
        'images-large/5.jpg'
        'images-large/6.jpg'
        'images-large/7.jpg'
        'images-large/8.jpg'
        'images-large/9.jpg'
        'images-large/10.jpg'
        'images-large/11.jpg'
        'images-large/12.jpg'
        'images-large/13.jpg'
        'images-large/14.jpg'
        'images-large/15.jpg'
        'images-large/16.jpg'
        'images-large/17.jpg'
        'images-large/18.jpg'
        'images-large/19.jpg'
        'images-large/20.jpg'
        'images-large/21.jpg'
        'images-large/22.jpg'
        'images-large/23.jpg'
        'images-large/24.jpg'
        'images-large/25.jpg'
        'images-large/26.jpg'
        'images-large/27.jpg'
        'images-large/28.jpg'
        'images-large/29.jpg'
        'images-large/30.jpg'
        'images-large/31.jpg'
        'images-large/32.jpg'
        'images-large/33.jpg'
        'images-large/34.jpg'
        'images-large/35.jpg'
        'images-large/36.jpg'
        'images-large/37.jpg'
        'images-large/38.jpg'
        'images-large/39.jpg'
        'images-large/40.jpg'
        'images-large/41.jpg'
        'images-large/42.jpg'
        'images-large/43.jpg'
        'images-large/44.jpg'
        'images-large/45.jpg'
        'images-large/46.jpg'
        'images-large/47.jpg'
        'images-large/48.jpg'
        'images-large/49.jpg'
        'images-large/50.jpg'
        'images-large/51.jpg'
        'images-large/52.jpg'
        'images-large/53.jpg'
        'images-large/54.jpg'
        'images-large/55.jpg'
        'images-large/56.jpg'
        'images-large/57.jpg'
        'images-large/58.jpg'
        'images-large/59.jpg'
        'images-large/60.jpg'
        'images-large/61.jpg'
        'images-large/62.jpg'
        'images-large/63.jpg'
        'images-large/64.jpg'
        'images-large/65.jpg'
        'images-large/66.jpg'
        'images-large/67.jpg'
        'images-large/68.jpg'
        'images-large/69.jpg'
        'images-large/70.jpg'
        'images-large/71.jpg'
        'images-large/72.jpg'
        'images-large/73.jpg'
        'images-large/74.jpg'
        'images-large/75.jpg'
        'images-large/76.jpg'
        'images-large/77.jpg'
        'images-large/78.jpg'
        'images-large/79.jpg'
        'images-large/80.jpg'
        'images-large/81.jpg'
        'images-large/82.jpg'
        'images-large/83.jpg'
        'images-large/84.jpg'
        'images-large/85.jpg'
        'images-large/86.jpg'
        'images-large/87.jpg'
        'images-large/88.jpg'
        'images-large/89.jpg'
        'images-large/90.jpg'
        'images-large/91.jpg'
        'images-large/92.jpg'
        'images-large/93.jpg'
        'images-large/94.jpg'
        'images-large/95.jpg'
        'images-large/96.jpg'
        'images-large/97.jpg'
        'images-large/98.jpg'
        'images-large/99.jpg'
        'images-large/100.jpg'
        'images-large/101.jpg'
        'images-large/102.jpg'
        'images-large/103.jpg'
        'images-large/104.jpg'
        'images-large/105.jpg'
        'images-large/106.jpg'
        'images-large/107.jpg'
        'images-large/108.jpg'
        'images-large/109.jpg'
        'images-large/110.jpg'
        'images-large/111.jpg'
        'images-large/112.jpg'    
      ]
    ), 1

    window.addEventListener 'hashchange', @setPageFromHash
    @setPageFromHash()
